import Framework7 from 'framework7/bundle';

const store = Framework7.createStore({
  state: {
    isWebAppInstallable: false,
    themeColor: null,
    themeMode: null,

    userAccessToken: null,
    isUserLoggedIn: false,
    currentUser: null,
    authLoading: false
  },
  actions: {
    setWebAppInstallableStatus: function( { state, dispatch }, status) {
      state.isWebAppInstallable = status;
    },
    setThemeColor: function( { state, dispatch }, color) {
      state.themeColor = color;
    },
    setThemeMode: function( { state, dispatch }, mode) {
      state.themeMode = mode;
    },

    setAuthorizationHeader: function( { state, dispatch }, token) {
      token = token ? 'Bearer ' + token: undefined;
      app.request.setup({
        headers: {
          Authorization: token
        }
      });
    },

    setUserSession: function( { state, dispatch }, token) {
      localStorage.setItem('User_Access_Token', token);
      console.log(token);
      dispatch('setAuthorizationHeader', token);
      state.userAccessToken = token;
      state.isUserLoggedIn = true;
    },
    clearUserSession: function( { state, dispatch }) {
      localStorage.removeItem('User_Access_Token');
      dispatch('setAuthorizationHeader', 0);
      state.userAccessToken = null;
      state.isUserLoggedIn = false;
      state.currentUser = null;
    },
    loginUser: async function({ state, dispatch }, credentials) {
      state.authLoading = true;
      try {
        const response = await app.request({
          url: '/api/auth/login',
          method: 'POST',
          data: credentials,
          dataType: 'json'
        });
        const data = response.data;
        console.log(data);
        if (!data.success) {
          throw new Error(
            data.message || 'Unable to sign in.');
        }
        dispatch('setUserSession', data.token);
        state.currentUser = data.user || null;
        return data;
      } catch (error) {
        const message =
        error?.message ||
        'Unable to sign in.';
        return {
          success: false,
          message
        };
      } finally {
        state.authLoading = false;
      }
    },

    logoutUser: async function({ state, dispatch }) {
      try {
        await app.request({
          url: '/api/auth/logout',
          method: 'POST',
          dataType: 'json'
        });
      } catch (error) {
        console.error(
          'Logout request failed:',
          error
        );
      } finally {
        dispatch(
          'clearUserSession'
        );
        app.views.current.router.navigate(
          '/login/',
          {
            reloadCurrent: true
          }
        );

      }
    },
    init: async function({ state, dispatch }) {
      const token = localStorage.getItem('User_Access_Token');
      if (!token) {
        state.isUserLoggedIn = false;
        state.currentUser = null;
        console.log('no token');
        return false;
      }
      dispatch('setAuthorizationHeader', token);
      state.authLoading = true;
      try {
        const response = await app.request({
          url: '/api/session',
          method: 'GET',
          dataType: 'json'
        });

        const data = response.data;
        console.log(data);

        if (data.success && data.authenticated) {
          state.isUserLoggedIn = true;
          state.currentUser = data.user || null;
          app.emit('user:login', state.currentUser);
          app.views.current.router.navigate('/home/', {
            reloadCurrent: true
          });
        } else {
          dispatch('clearUserSession');
          return false;
        }

      } catch (error) {
        alert('error');
        dispatch('clearUserSession');
        return false;
      } finally {
        state.authLoading = false;
      }
    },
    signupUser: async function({ state }, userData) {

      state.authLoading = true;

      try {

        const response = await app.request({
          url: '/api/auth/signup',
          method: 'POST',
          data: userData,
          dataType: 'json'
        });

        const data = response.data;

        if (!data.success) {
          throw new Error(
            data.message || 'Unable to sign up.'
          );
        }

        return data;

      } catch (error) {

        return {
          success: false,
          message:
          error?.message ||
          'Unable to sign up.'
        };

      } finally {
        state.authLoading = false;
      }
    },

    verifySignupOtp: async function({ state, dispatch }, data) {

      state.authLoading = true;

      try {

        const response = await app.request({
          url: '/api/auth/verify-otp',
          method: 'POST',
          data: data,
          dataType: 'json'
        });

        const result = response.data;

        if (!result.success) {
          throw new Error(
            result.message ||
            'OTP verification failed.'
          );
        }

        if (result.token) {
          dispatch(
            'setUserSession',
            result.token
          );
        }

        state.currentUser =
        result.user || null;

        return result;

      } catch (error) {

        return {
          success: false,
          message:
          error?.message ||
          'OTP verification failed.'
        };

      } finally {
        state.authLoading = false;
      }
    },

    requestOtp: async function({ state }, email) {

      state.authLoading = true;

      try {

        const response = await app.request({
          url: '/api/auth/request-otp',
          method: 'POST',
          data: {
            email: email
          },
          dataType: 'json'
        });

        const data = response.data;

        if (!data.success) {
          throw new Error(
            data.message ||
            'Unable to send OTP.'
          );
        }

        return data;

      } catch (error) {

        return {
          success: false,
          message:
          error?.message ||
          'Unable to send OTP.'
        };

      } finally {
        state.authLoading = false;
      }
    }
  },
  getters: {
    isWebAppInstallable: function( { state }) {
      return state.isWebAppInstallable;
    },
    themeColor: function( { state }) {
      return state.themeColor;
    },
    themeMode: function( { state }) {
      return state.themeMode;
    },
    userAccessToken: function( { state }) {
      return state.userAccessToken;
    },
    isUserLoggedIn: function( { state }) {
      return state.isUserLoggedIn;
    },
    currentUser: function( { state }) {
      return state.currentUser;
    }
  }
});

export default store;